import React from "react";

import moment from "moment";

type Props = {
  userDataList: any;
  setChatOpen: (value: React.SetStateAction<boolean>) => void;
  handleGroudData: (data: any) => void;
  setUserChatId: (value: React.SetStateAction<string>) => void;
};

export const UsersList = ({
  userDataList,
  setChatOpen,
  handleGroudData,
  setUserChatId,
}: Props) => {
  return !!userDataList?.length ? (
    userDataList.map((item: any) => (
      <div key={item?._id} className="chat_list">
        <div
          style={{ cursor: "pointer" }}
          className="chat_people"
          onClick={() => {
            setChatOpen(true);
            handleGroudData(item);
            setUserChatId(item?._id);
          }}
        >
          <div
            className="chat_img"
            style={{
              width: "36px",
              height: "36px",
              position: "relative",
              flexShrink: 0,
            }}
          >
            <div
              style={{
                width: "36px",
                height: "36px",
                borderRadius: "50%",
                overflow: "hidden",
                backgroundColor: "#00AEEF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {item?.sender?.userProfile?.[0] && (
                <img
                  style={{
                    cursor: "pointer",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                  src={item?.sender?.userProfile[0]}
                  alt=""
                  onError={(e) => {
                    (e.target as HTMLImageElement).style.display = "none";
                  }}
                />
              )}
              <span
                style={{
                  color: "#ffffff",
                  fontSize: "13px",
                  fontWeight: 600,
                  cursor: "pointer",
                }}
              >
                {(item?.sender?.firstName?.trim() || item?.sender?.lastName?.trim())?.[0]?.toUpperCase() || "?"}
              </span>
            </div>
            <span
              style={{
                position: "absolute",
                bottom: "-1px",
                right: "-1px",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                backgroundColor: item?.sender?.socketId ? "#00E676" : "#bdbdbd",
                border: "2px solid #fff",
              }}
              title={item?.sender?.socketId ? "Online" : "Offline"}
            />
          </div>
          <div className="chat_ib">
            <div style={{ minWidth: 0, flex: 1 }}>
              <h3 style={{ cursor: "pointer" }}>{item?.sender?.firstName?.trim() || item?.sender?.lastName?.trim() || "Nutzer"}</h3>
              <p style={{ cursor: "pointer" }}>
                {item?.lastMessage?.data?.length > 25
                  ? item?.lastMessage?.data?.substring(0, 25) + "..."
                  : item?.lastMessage?.data}
              </p>
            </div>
            <div style={{ flexShrink: 0, textAlign: "right", display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "4px" }}>
              <div style={{ fontSize: "11px", color: "#989898", whiteSpace: "nowrap" }}>
                {moment(item?.lastMessage?.updatedAt).format("DD.MM.YYYY")}
              </div>
              {!!item?.unreadCount && (
                <div style={{
                  backgroundColor: "#00AEEF",
                  color: "#fff",
                  borderRadius: "10px",
                  minWidth: "18px",
                  height: "18px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "10px",
                  fontWeight: 600,
                  padding: "0 5px",
                }}>
                  {item?.unreadCount}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    ))
  ) : (
    <p
      style={{
        display: "flex",
        fontSize: "13px",
        padding: "16px 12px",
        justifyContent: "center",
        color: "#989898",
      }}
    >
      Keine Benutzer gefunden
    </p>
  );
};
